import React, { useState } from 'react'
import { Select, Typography, Button, Row, Col, Modal } from 'antd'
import _ from 'lodash'
import { connect } from 'react-redux'
import { edithealthcoach } from '../../store/action/patient.action'
import PropTypes from 'prop-types'
const { Option } = Select
const { Text, Title } = Typography
const { confirm } = Modal
const HealthCoachEdit = (props) => {
  const {
    healthcoach,
    healthcoachdetail,
    patientId,
    editHealthCoach,
    updateHcDetail,
    patientName,
  } = props
  const [select, setSelect] = useState('')
  const [hcdetail, setHcDetail] = useState({
    id: '',
    firstname: '',
    lastname: '',
    email: '',
  })

  const showConfirm = () => {
    confirm({
      title: `Do You Want To assign \'${hcdetail.firstname} ${hcdetail.lastname}\' to \'${patientName}\'`,
      onOk() {
        try {
          const response = props.edithealthcoach(patientId, select)
          if (response) {
            editHealthCoach()
            updateHcDetail(hcdetail)
            setSelect('')
          }
        } catch (e) {
          return console.log(' errors!')
        }
      },
      onCancel() {
        setSelect('')
      },
    })
  }

  const handleChange = (userId) => {
    setSelect(userId)
    console.log('Selected user ID:', userId)
    const selectedUser = healthcoach.users.find((user) => user._id === userId)
    if (selectedUser) {
      setHcDetail({
        _id: userId,
        firstname: selectedUser.firstname,
        lastname: selectedUser.lastname,
        email: selectedUser.email,
      })
    }
  }
  const handleSave = () => {
    showConfirm()
    console.log('Save button clicked')
  }

  return (
    <div className='existing-healthcoach-container'>
      <Title level={3} className='healthcoach-heading'>
        Health Coach:{' '}
      </Title>
      {!_.isEmpty(healthcoachdetail) && (
        <div className='healthcoach-details'>
          <Text className='detail-title'>Present Health Coach</Text>
          <div className='detail-row'>
            <Text className='detail-label'>Name:</Text>
            <Text className='detail-value'>{`${healthcoachdetail.firstname} ${healthcoachdetail.lastname}`}</Text>
          </div>
          <div className='detail-row'>
            <Text className='detail-label'>Email:</Text>
            <Text className='detail-value'>{healthcoachdetail.email}</Text>
          </div>
        </div>
      )}
      <Row gutter={16} style={{ marginTop: '1rem', width: '100%' }}>
        <Col span={18}>
          <Select
            style={{
              width: '100%',
              borderColor: '#1677ff',
            }}
            placeholder='Select a health coach'
            onChange={handleChange}
            value={select || undefined}
            autoFocus={true}
          >
            {healthcoach.users.map(
              (user) =>
                (_.isEmpty(healthcoachdetail) ||
                  user.email != healthcoachdetail.email) && (
                  <Option key={user._id} value={user._id}>
                    {`${user.firstname} ${user.lastname} (${user.email})`}
                  </Option>
                )
            )}
          </Select>
        </Col>
        <Col span={6}>
          <Button
            style={{ width: '100%' }}
            className={!select ? 'disabled-button' : ''}
            onClick={handleSave}
            disabled={!select}
          >
            Save
          </Button>
        </Col>
      </Row>
    </div>
  )
}

// HealthCoachEdit.prototype={
//     healthcoach:PropTypes.object,
//     healthcoachdetail:PropTypes.object,
//     patientId:PropTypes.string
// }
HealthCoachEdit.propTypes = {
  healthcoach: PropTypes.object.isRequired,
  healthcoachdetail: PropTypes.object,
  patientId: PropTypes.string.isRequired,
  editHealthCoach: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {}
}
const mapDispatchToProps = (dispatch) => {
  return {
    edithealthcoach: (patientId, select) =>
      dispatch(edithealthcoach(patientId, select)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HealthCoachEdit)
